import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CloudIcon from '@mui/icons-material/CloudUpload';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid2';
import { APIContext } from '../Contexts/APIContext';
import { useContext } from 'react';

interface IProps {
    onDrop: (newFile: File | null) => void;
    onDelete: () => void;
    file: File | null;
    acceptedTypes?: string;
}

const boxStyle = [{
    display: 'flex',
    p: 2,
    bgcolor: 'grey.200',
    width: '100%',
    height: '100%',
    border: '2px dashed grey',
    borderColor: 'grey.500',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center'
},
{
    '&:hover': {
        bgcolor: 'grey.300',
    },
}];

export default function SingleFileUpload(props: IProps) {
    const { onDrop, onDelete, file, acceptedTypes } = props;
    const { showMessage } = useContext(APIContext);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.item(0)) {
            const newFile = event.target.files.item(0);

            //Limit file size to 250MB
            if (newFile!.size >= (0.25 * 1024 * 1024 * 1024)) {
                showMessage('warning', "Cannot upload file size greater than 250MB.")
            } else {
                onDrop(newFile);
            }
        }
    }

    const dragEvents = {
        onDragEnter: (event: React.DragEvent<HTMLElement>) => {
            event.stopPropagation();
            event.preventDefault();
        },
        onDragLeave: (event: React.DragEvent<HTMLElement>) => {
            event.stopPropagation();
            event.preventDefault();
        },
        onDragOver: (event: React.DragEvent<HTMLElement>) => {
            event.stopPropagation();
            event.preventDefault();
        },
        onDrop: (event: React.DragEvent<HTMLElement>) => {
            event.stopPropagation();
            event.preventDefault();
            if (event.dataTransfer.files.length === 1) onDrop(event.dataTransfer.files.item(0));
        }
    }

    return (
        <Grid container spacing={2}>
            {file !== null ?
                <Grid>
                    <Chip label={file.name} onDelete={onDelete} />
                </Grid>
                :
                <>
                    <Grid size={12}>
                        <Typography>Maximum file size 250MB.</Typography>
                    </Grid>
                    <Grid size={12}>
                        <input
                            onChange={handleChange}
                            style={{ display: 'none' }}
                            id="file-upload"
                            type="file"
                            accept={acceptedTypes}
                        />
                        <label htmlFor="file-upload" {...dragEvents} >
                            <Box sx={boxStyle}>
                                <Stack alignItems="center">
                                    <CloudIcon color="action" />
                                    <Typography>Click or Drag & Drop to Upload a File</Typography>
                                    <Typography variant="body2">You may only upload one file</Typography>
                                </Stack>
                            </Box>
                        </label>
                    </Grid>
                </>
            }
        </Grid>
    );
}